import { Navigate, useLocation, useParams } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { useStore } from 'models/stores';

function LanguageRedirect() {
  const { companyStore } = useStore();
  const location = useLocation();
  const { name } = useParams();
  companyStore.setCurrent(name);

  if (companyStore.current) {
    let url = location.pathname.split('/');
    url.splice(2, isNaN(url[2]) ? 1 : 0, companyStore.current.defaultLanguage);
    url = url.join('/') + location.search;
    return <Navigate to={url} replace />;
  }

  return null;
}

export default observer(LanguageRedirect);
